import { render, staticRenderFns } from "./SummaryDoubleBarChart.vue?vue&type=template&id=62159bbf"
import script from "./SummaryDoubleBarChart.vue?vue&type=script&lang=js"
export * from "./SummaryDoubleBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard});
